<template>
  <div>
    <div class="page-title">
      <h3>{{ 'ProfileTitle' | localize }}</h3>
    </div>

    <form class="form" @submit.prevent="submitHandler">
      <div class="input-field">
        <input
          id="description"
          type="text"
          v-model="name"
          :class="{ invalid: $v.name.$dirty && !$v.name.required }"
        />
        <label for="description">{{ 'Name' | localize }}</label>
        <small
          class="helper-text invalid"
          v-if="$v.name.$dirty && !$v.name.required"
          >{{ 'Message_EnterName' | localize }}</small
        >
      </div>
      <button class="btn waves-effect waves-light" type="submit">
        {{ 'Btn_Update' | localize }}
        <i class="material-icons right">send</i>
      </button>
    </form>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import { mapGetters, mapActions } from 'vuex';

export default {
  metaInfo() {
    return { title: this.$title('ProfileTitle') };
  },
  data: () => ({
    name: '',
  }),
  validations: {
    name: { required },
  },
  mounted() {
    this.name = this.info.name;

    this.isUaLocale = this.info.locale === 'uk-UA';
    setTimeout(() => {
      this.select = M.FormSelect.init(this.$refs.selectCategory);
      M.updateTextFields();
    }, 0);
  },
  computed: {
    ...mapGetters(['info']),
  },

  methods: {
    ...mapActions(['updateInfo']),
    async submitHandler() {
      if (this.$v.$invalid) {
        this.$v.$touch();
        return;
      }

      try {
        await this.updateInfo({
          name: this.name,
        });
      } catch (error) {}
    },
  },
};
</script>

<style>
.switch {
  margin-bottom: 2rem;
}
</style>
